<div class="row justify-content-center">
    <div class="col-12 col-md-10 col-lg-8 col-xl-7 text-center">                        
        <h2 class="card-title section-title">Branch Locator <span class="wow"></span></h2>
        <p>Over 110 locations all over india - Serving and enabling all your financial solutions. Just drop in for personalized review services and guidance<br><br></p>
        <div class="card" style="overflow: visible;">
            <div class="card-body">
                <div class="tab-listing d-none d-md-flex">
                    <div class="tab-list">
                        <a href="#" data-target="investment-centres" class="active">Investment Centres</a>
                    </div>
                    <div class="tab-list">
                        <a href="#" data-target="wealth-management">Wealth Management Centres</a>
                    </div>
                    <div class="tab-list">
                        <a href="#"  data-target="network-group">Advisor Network Group</a>
                    </div>
                </div>
                <div class="form-group custom-dropdown d-md-none" style="z-index: 97;">
                    <label>Select Branch Type</label>
                    <span class="selected-item  form-control">Investment Centres</span>
                    <ul>
                        <li class="active default"><a href="#" >Investment Centres</a></li>
                        <li><a href="#" >Wealth Management Centres</a></li>
                        <li><a href="#" >Advisor Network Group</a></li>
                    </ul>
                </div>
                <div class="tab-wrapper">
                    <div class="tab" id="investment-centres" style="display: block;">
                        <div>
                            <form action="" class="d-md-flex justify-content-between">
                                <div class="form-group custom-dropdown">
                                    <span class="ashish selected-item  form-control" >BajajCapital Limited</span>
                                    
                                </div>
                                <div class="form-group custom-dropdown">
                                    <span class="selected-item  form-control">Mezzanine Floor, 97, Bajaj House, Nehru Place, New Delhi - 110019, India</span>
                                    <ul>
                                    
                                    </ul>
                                </div>
                            </form>
                            <ng-container >
                            <h3>Investment Centres</h3>
                            <p>These facilities enable clients who are looking for investment solutions for various purposes such as wealth creation and goal-based investments like retirement, child's education etc.</p>
                            </ng-container>
                            <ng-container>
                                <h3>Wealth Management Centres</h3>
                                <p>These facilities primarily cater to corporate and HNI clientele. They have selective clients who are aiming for wealth creation and/or wealth protection. </p>
                            </ng-container>
                            <ng-container>
                                    <h3>Advisor Network Group</h3>
                                    <p>Advisor Network Group is a business channel that works on a sub-broking model with their active agents offering all kinds of financial solutions. </p>
                            </ng-container>
                            <div class="location-box" >
                                <div class="location-header">
                                    <h4><img src="assets/images/placeholder.svg" alt="" width="12"> BajajCapital Limited</h4>
                                </div>
                                <div class="location-body">
                                    <p class="label"><strong>Address:</strong><span>Novus Tower</span></p>
                                    <p class="label"><strong>City:</strong><span>Gurgaon</span></p>
                                    <p class="label"><strong>Mobile:</strong><span><a href="branchDetail.Mobile">7678-123-123</a></span></p>
                                    <p class="label"><strong>Email:</strong><span><a href="mailto:branchDetail.Email">bajajcapital@gmail.com</a></span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="tab" id="wealth-management">                       
                        <div>
                            <form action="" class="d-md-flex justify-content-between">
                                <div class="form-group custom-dropdown">
                                    <span class="selected-item  form-control">{{spanCity}}</span>
                                    <ul>
                                        <li *ngFor="let city of cities" [class.active]="spanCity === city">
                                            <a (click)="selectBranchFromCity(city)">{{city}}</a>
                                        </li>                                                    
                                    </ul>
                                </div>
                                <div class="form-group custom-dropdown">
                                    <span class="selected-item  form-control">{{spanBranch}}</span>
                                    <ul>
                                        <li *ngFor="let branch of cityWiseBranchList" [class.active]="spanBranch === branch.BranchName" >
                                            <a (click)="loadBranchAddress(branch.BranchCode)">{{branch.BranchName}}</a>
                                        </li>
                                    </ul>
                                </div>
                            </form>
                            <h3>Wealth Management Center Ashu2</h3>
                            <p>These facilities primarily cater to corporate and HNI clientele. They have selective clients who are aiming for wealth creation and/or wealth protection.</p>
                            <div class="location-box" *ngIf="isAddress">
                                <div class="location-header">
                                    <h4><img src="assets/images/placeholder.svg" alt="" width="12"> {{branchDetail.BranchName}}</h4>
                                </div>
                                <div class="location-body">
                                    <p class="label"><strong>Address:</strong><span>{{branchDetail.Address}}</span></p>
                                    <p class="label"><strong>City:</strong><span>{{branchDetail.CityName}}</span></p>
                                    <p class="label"><strong>Mobile:</strong><span><a href="branchDetail.Mobile">{{branchDetail.Mobile}}</a></span></p>
                                    <p class="label"><strong>Email:</strong><span><a href="mailto:branchDetail.Email">{{branchDetail.Email}}</a></span></p>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <!-- <div class="tab" id="network-group">                      
                        <div>
                            <form action="" class="d-md-flex justify-content-between">
                                <div class="form-group custom-dropdown">
                                    <span class="selected-item  form-control">{{spanCity}}</span>
                                    <ul>
                                        <li *ngFor="let city of cities" [class.active]="spanCity === city">
                                            <a (click)="selectBranchFromCity(city)">{{city}}</a>
                                        </li>                                                    
                                    </ul>
                                </div>
                                <div class="form-group custom-dropdown">
                                    <span class="selected-item  form-control">{{spanBranch}}</span>
                                    <ul>
                                        <li *ngFor="let branch of cityWiseBranchList" [class.active]="spanBranch === branch.BranchName" >
                                            <a (click)="loadBranchAddress(branch.BranchCode)">{{branch.BranchName}}</a>
                                        </li>
                                    </ul>
                                </div>
                            </form>
                            <h3>Advisor Network Group Ashu3</h3>
                            <p>Advisor Network Group is a business channel that works on a sub-broking model with their active agents offering all kinds of financial solutions.</p>
                            <div class="location-box" *ngIf="isAddress">
                                <div class="location-header">
                                    <h4><img src="assets/images/placeholder.svg" alt="" width="12"> {{branchDetail.BranchName}}</h4>
                                </div>
                                <div class="location-body">
                                    <p class="label"><strong>Address:</strong><span>{{branchDetail.Address}}</span></p>
                                    <p class="label"><strong>City:</strong><span>{{branchDetail.CityName}}</span></p>
                                    <p class="label"><strong>Mobile:</strong><span><a href="branchDetail.Mobile">{{branchDetail.Mobile}}</a></span></p>
                                    <p class="label"><strong>Email:</strong><span><a href="mailto:branchDetail.Email">{{branchDetail.Email}}</a></span></p>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="text-center">
            <a [routerLink]="['/rm-assistance']" class="read-more" >Match with a Relationship Manager<i class="fas fa-chevron-right right-arrow"></i></a>
        </div>
    </div>
</div>